import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, Kanban, PhoneCall, BarChart3, User } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const MobileBottomNav = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  // Don't show during loading, on login page, or meeting room
  if (loading) {
    return null;
  }
  
  if (location.pathname === '/login' || location.pathname.startsWith('/meet/')) {
    return null;
  }
  
  // Don't show if not logged in
  if (!user) {
    return null;
  }
  
  // R2G users have different nav
  if (user.role === 'R2G') {
    return null;
  }

  const navItems = [
    { path: '/dashboard', label: 'Home', icon: LayoutDashboard },
    { path: '/leads-board', label: 'Leads', icon: Kanban },
    { path: '/quick-call', label: 'Call', icon: PhoneCall },
    { path: '/analytics', label: 'Stats', icon: BarChart3, managerOnly: true },
    { path: '/profile', label: 'Profile', icon: User },
  ];

  const isManager = ['Super Admin', 'CEO', 'Manager'].includes(user.role);
  const filteredItems = navItems.filter(item => !item.managerOnly || isManager);

  return (
    <nav className="mobile-bottom-nav lg:hidden safe-area-bottom" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around">
        {filteredItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `mobile-bottom-nav-item flex-1 haptic-feedback ${isActive ? 'active text-primary' : 'text-gray-500'}`
            }
            data-testid={`mobile-nav-${item.path.slice(1)}`}
          >
            <item.icon className="h-5 w-5" />
            <span className="text-[10px] font-medium mt-0.5">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
